/**
 * Canonical stock categories — used by Add product and New order requests.
 * Keep this list aligned with business inventory groupings.
 */
export const STOCK_CATEGORIES = [
  'Pens & pencils',
  'Markers & highlighters',
  'Notebooks & exercise books',
  'Paper & envelopes',
  'Files, folders & binders',
  'Staplers, punches & clips',
  'Tape, glue & adhesives',
  'Erasers, rulers & math sets',
  'Arts & crafts',
  'School bags & pencil cases',
  'Printing & cartridges',
  'Desk & office accessories',
  'Other',
];

/** @returns {{ value: string, label: string }[]} */
export function stockCategorySelectOptions() {
  return [{ value: '', label: 'Select category…' }, ...STOCK_CATEGORIES.map((c) => ({ value: c, label: c }))];
}

/**
 * Full category list for order forms: catalog + any extra categories already used on products.
 * @param {{ category?: string }[]} products
 * @returns {string[]}
 */
export function mergedStockCategories(products) {
  const fromDb = Array.from(
    new Set((products || []).map((p) => (p.category || '').trim()).filter(Boolean))
  );
  const catalog = new Set(STOCK_CATEGORIES);
  const extras = fromDb.filter((c) => !catalog.has(c));
  return [...STOCK_CATEGORIES, ...extras].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}
